import React from 'react';
import SignIn from '../components/SignIn';
import SignUpImg from "../assets/signup_img.png"

const SignInPage = () => {
  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <img
        src={SignUpImg}
        alt="Background"
        style={{ width: '70%', objectFit: 'cover' }}
      />
      <SignIn />
    </div>
  );
};

export default SignInPage;
